import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTrendsData,
  fetchEquipmentsData,
  fetchRolesCountData,
} from "../../../redux/slice/DashboardSlice/DashboardSlice";
import { fetchJobSiteData } from "../../../redux/slice/InspectionSlice/InspectionSlice";
import {
  fetchJobSiteCount,
  fetchEquipTypes,
} from "../../../redux/slice/SitesSlice/SitesSlice";
import Loader from "../../Loader/Loader";
import PropTypes from "prop-types";
import EquipmentLineChart from "./charts/EquipmentLineChart";
import ColumnsChart from "./charts/ColumnsChart";
import BarChart from "./charts/BarChart";
import LineChart from "./charts/LineChart";

function StatCharts({
  endDate,
  startDate,
  search,
  setSearch,
  comp,
  jobSiteId,
}) {
  const dispatch = useDispatch();
  const [selectedJobsite, setSelectedJobsite] = useState(null);
  const [selectedEquipmentType, setSelectedEquipmentType] = useState(null);

  const { JobSiteData, status } = useSelector((state) => state?.Inspections);
  const { TrendsData, RolesCount, EquipmentsData } = useSelector(
    (state) => state.Dashboard
  );
  const { JobSiteCount, EquipTypes } = useSelector((state) => state.Sites);

  const formattedData = TrendsData
    ? TrendsData?.data?.map((item) => ({
      date: item.date,
      count: item.count,
    }))
    : [];

  /** ---------- Fetching Logic ---------- **/
  useEffect(() => {
    if (search && comp) {
      dispatch(
        fetchTrendsData({ start: startDate, end: endDate, compId: comp, jobSite: jobSiteId })
      );
      dispatch(
        fetchRolesCountData({ start: startDate, end: endDate, compId: comp, jobSite: jobSiteId })
      );
      dispatch(
        fetchEquipmentsData({ start: startDate, end: endDate, compId: comp, jobSite: jobSiteId })
      );
      setSelectedEquipmentType(null);
    }
  }, [dispatch, search, comp, startDate, endDate, jobSiteId]);

  useEffect(() => {
    if (comp && search) {
      dispatch(fetchJobSiteData(comp));
      setSelectedEquipmentType(null);
      setSelectedJobsite(null);
    }
  }, [comp, search]);

  useEffect(() => {
    if (selectedJobsite) {
      dispatch(fetchJobSiteCount({ id: selectedJobsite, start: startDate, end: endDate, type: selectedEquipmentType }));
      dispatch(fetchEquipTypes({ id: selectedJobsite }));
      setSelectedEquipmentType(null);
      setSearch(false);
    }
  }, [selectedJobsite]);

  useEffect(() => {
    if (selectedEquipmentType) {
      dispatch(fetchJobSiteCount({ id: selectedJobsite, start: startDate, end: endDate, type: selectedEquipmentType }));
    }
  }, [selectedEquipmentType]);

  useEffect(() => {
    if (JobSiteData?.data?.JobSitesData?.length > 0 && !jobSiteId) {
      setSelectedJobsite(JobSiteData.data.JobSitesData[0]?.id);
    } else if (jobSiteId) {
      setSelectedJobsite(jobSiteId);
    }
  }, [JobSiteData]);

  /** ---------- JSX ---------- **/
  return (
    <div className="mb-4 container-fluid " style={{ marginTop: "50px", overflowX: "hidden" }}>
      <div className="row gy-4 ">
        <div className="col-12 col-lg-7 dark-panel2" >
          <div className="shadow rounded p-3 h-100">
            <div className="mb-3 dark-panel2" style={{ minHeight: "235px" }}>
              <EquipmentLineChart data={EquipmentsData ? EquipmentsData?.data : []} />
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-5">
          <div className=" shadow rounded p-3 h-100 dark-panel2">
            <div className="mb-3 row g-3 align-items-center">
              <div className="col-12 col-md-6">
                <select
                  className="form-select w-100"
                  disabled={jobSiteId}
                  value={selectedJobsite || ""}
                  onChange={(event) => setSelectedJobsite(event.target.value)}
                >
                  <option value="">Select JobSite</option>
                  {JobSiteData?.data?.JobSitesData?.map((site) => (
                    <option key={site._id} value={site._id}>
                      {site.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-md-6">
                <select
                  className="form-select w-100"
                  value={selectedEquipmentType || ""}
                  onChange={(event) => setSelectedEquipmentType(event.target.value)}
                >
                  <option value="null">All</option>
                  {EquipTypes?.map((site, index) => (
                    <option key={index} value={site?.equipType}>
                      {site.equipType}
                    </option>
                  ))}
                </select>
              </div>
            </div>


            <div style={{ minHeight: "235px" }}>
              <ColumnsChart
                data={JobSiteCount && selectedJobsite && JobSiteCount.length > 0 ? JobSiteCount[0] : {}}
                comp={comp}
                jobSite={selectedJobsite}
                equipType={selectedEquipmentType}
              />
            </div>
          </div>
        </div>

        <div className="col-12 ">
          <div className="dark-panel2 shadow rounded p-3">
            <BarChart data={RolesCount ? RolesCount?.data : []} />
          </div>
        </div>

        <div className="col-12">
          <div className="dark-panel2 shadow rounded p-3">
            <LineChart data={formattedData} />
          </div>
        </div>
      </div>

      {status === "loading" && <Loader />}
    </div>
  );
}

export default StatCharts;

StatCharts.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  setSearch: PropTypes.func,
  search: PropTypes.bool,
  comp: PropTypes.string,
  jobSiteId: PropTypes.string,
};
